import { render, staticRenderFns } from "./details_alertes.vue?vue&type=template&id=177f81ea"
import script from "./details_alertes.vue?vue&type=script&lang=js"
export * from "./details_alertes.vue?vue&type=script&lang=js"
import style0 from "./details_alertes.vue?vue&type=style&index=0&id=177f81ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports